export default "__VITE_ASSET__$Aw8tGFb__"